import React, { useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { } from "react-icons/fa";
import Sidenav from './nav';

const drawerWidth = 240;

const App = () => {
    const navigate = useNavigate()
    const location = useLocation();




    return (
        <Routes>
            <Route path="/" element={<Navigate replace to="/nav/" />} />
            <Route path="/nav/*" element={<Sidenav />} exact />

        </Routes>
    );
}



export default App;
